import protoRoot from "../proto-root";

function create({ avatar, micSensitivity, motionDetectionSensitivity }) {
  const DataRemoteSettings = protoRoot.lookupType("comm.DataRemoteSettings");
  const Avatar = protoRoot.lookupType("comm.Avatar");
  const MicSensitivity = protoRoot.lookupEnum("comm.MicSensitivity");
  const MotionSensitivity = protoRoot.lookupEnum(
    "comm.MotionDetectionSensitivity"
  );

  const remoteSettings = DataRemoteSettings.create({
    avatar: avatar
      ? Avatar.create({
          objectId: avatar.objectId
        })
      : undefined,
    micSensitivity: MicSensitivity.values[micSensitivity],
    supportedSensitivities: Object.values(MicSensitivity.values),
    motionDetectionSensitivity:
      MotionSensitivity.values[motionDetectionSensitivity]
  });

  return remoteSettings;
}

export default {
  create
};

// Avatar avatar = 1;
// MicSensitivity micSensitivity = 2;
// repeated MicSensitivity supportedSensitivities = 3;
// MotionDetectionSensitivity motionDetectionSensitivity = 4;
